import React from "react";
import classNames from "classnames";
import { IOneImage } from "./Common";
import LazyLoadColumn from "./LazyLoadColumn";
import useGalleryCheck from "./useGalleryCheck";
import { GalleryCheck } from "./GalleryCheck";
import StatusTag from '../Tag/StatusTag';
import { IGalleryStatus } from '../../global.d';
// 请在外层直接引用gallery-list样式

const Column4 = (props: IOneImage) => {
  const { checkShow, index, disabled } = useGalleryCheck(props);
  const { hidePayedTag, isPayed } = props;
  const canShowPayedTag = isPayed && !hidePayedTag;

  return (
    <div className={"column column4"} onClick={props.onClick}>
      {/*<LazyLoadColumn>

      </LazyLoadColumn>*/}
      <div
        data-index={
          props && typeof props.index != "undefined" ? props.index * 1 + 1 : 0
        }
        data-id={props.id}
        className={classNames("img-wrapper column4-img-wrapper", { disabled })}
        style={{
          background: `url(${props.src}) rgba(255,255,255,0.5) center top / cover no-repeat`,
          // backgroundSize: 'cover'
        }}
      >
        {checkShow ? <GalleryCheck index={index} /> : null}
        {canShowPayedTag ? <StatusTag
            status={IGalleryStatus.payed}
            className={'status payed-status'}
            fontSize={12}
          /> : null}
      </div>
      {props.children}
    </div>
  );
};

export default Column4;
